import React, { useEffect, useState, useRef } from "react";
import "../../Styles/styles-StatusTracker.css";
import { useSelector, useDispatch } from "react-redux";
import { 
    Tooltip, message,
    Modal, Input, Tag, Button, notification, Spin
} from "antd";
import { ACWRDot } from './ACWRDot';
import dayjs from 'dayjs';
import { FaPlus } from "react-icons/fa6";
import { GoPencil } from "react-icons/go";
import moment from "moment";import { useAuth0 } from "@auth0/auth0-react";
import { 
    createCustomStatus, 
    selectPlayerStatus, 
    deletePlayerStatus, 
    deleteCustomStatus 
} from '../../store/actions/statustracker.actions'
import { PlusOutlined, CheckOutlined, DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import { TwitterPicker, ChromePicker, BlockPicker } from 'react-color';
import { StatusUpdater } from "./StatusUpdater";


export const StatusTrackerCell = ({ uniqueKey, dateHeaders }) => {
    const dispatch = useDispatch();
    const FLAG_SIZE = '27px';
    const {
        players,
        info: { 
            team_colors: teamColors,
            acwr_upper_limit,
            acwr_lower_limit,
            coach_list
         },
         metrics,
         misc: { flag_names_by_type }
    } = useSelector(({ team }) => team);

    
    const [player, setPlayer] = useState();
    const [dateStr, setDateStr] = useState();
    const [cellBGColor, setCellBGColor] = useState("white");
    const [cellInfo, setCellInfo] = useState();
    const [ACWRDotTooltipTxt, setACWRDotTooltipTxt] = useState();
    const [ACWRDotContent, setACWRDotContent] = useState();
    const [flagNum, setFlagNum] = useState();
    const [flagTooltipTxt, setFlagTooltipTxt] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [customInputVisible, setCustomInputVisible] = useState(false);
    const [selectedTagBGColor, setSelectedTagBGColor] = useState();
    const [selectedTagStatusId, setSelectedTagStatusId] = useState();
    const [editingStatus, setEditingStatus] = useState(null);
    const { user } = useAuth0();
    const isStaffEmail = user?.email?.endsWith("gpsdataviz.com");
    
    const {
    cellLoading: { [`${uniqueKey}Cell`]: uniqueKeyCellLoading },
    statuses,
    trackerData,
    modalLoading: { [`${uniqueKey}Modal`]: uniqueKeyModalLoading }
    } = useSelector(({ statusTracker }) => statusTracker);


    const inputRef = useRef(null);
    useEffect(() => {
        var _a;
        if (customInputVisible) {
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [customInputVisible]);

    useEffect(() => {
        if (trackerData && Object.keys(trackerData).length > 0) {
            setCellInfo(trackerData[uniqueKey]);
        }
    }, [trackerData[uniqueKey]])

    useEffect(() => {
        const uniqueKeySplit = uniqueKey.split('_');
        const player = players.filter(p => p.player_id === Number(uniqueKeySplit[0]));
        setPlayer(player[0]);
        setDateStr(uniqueKeySplit[1]);
        
    }, [uniqueKey])

    let circleIdx = 0;
    const key_metrics = (metrics || []).filter(metric => metric.is_key_metric).sort((a, b) => a.order - b.order);

    const acwr_color = (value) => {
        let color = "#FFC83D";
        if (value > acwr_upper_limit) {return "#d9534f" }
        else if (value < acwr_lower_limit) { color = "#FFC83D" }
        else if (acwr_lower_limit <= value && value <= acwr_upper_limit) { color = "#31B452" }
        else { color = "#d3d3d3" }
        return color;
    }

    useEffect(() => {
        if (cellInfo && Object.keys(cellInfo).length > 0) {
                        setCellBGColor(cellInfo?.player_data_exists_for_curr_day ? cellInfo?.status?.color : '#f2f2f2');

            if (cellInfo?.player_data_exists_for_curr_day){
                setACWRDotTooltipTxt(getACWRTooltip());

                const flags = cellInfo?.flags;
                // mock flag count data
                setFlagNum(Object.keys(flags).length);
            } else {
                setACWRDotTooltipTxt(null);
                setFlagNum(null);
            }

            // this will anyway display grayed out acwr circles if the data doesn't exist
            setACWRDotContent(key_metrics.map((metric) => {
                const acwr_key = `${metric.key}_ACWR`;
                const acwr_value = cellInfo[acwr_key];
                circleIdx += 1;
                
                return (
                    <ACWRDot 
                        key={`ACWRCircle${uniqueKey}${circleIdx}`}
                        circleColor={acwr_color(acwr_value)}
                    />
                );
            }));

            setFlagTooltipTxt(getFlagTooltip());
            setSelectedTagStatusId(cellInfo?.status?.status_id || cellInfo?.status?.id);
            setSelectedTagBGColor(cellInfo?.status?.color);
            setCellBGColor((cellInfo?.status && Object.keys(cellInfo?.status).length > 0) ? cellInfo?.status?.color : '#f2f2f2');
        } else {
            setACWRDotContent(key_metrics.map((metric) => {
                circleIdx += 1;
                return (
                    <ACWRDot 
                        key={`ACWRCircle${uniqueKey}${circleIdx}`}
                        circleColor={acwr_color(undefined)}
                    />
                );
            }));
        }
    }, [cellInfo])


    const getACWRTooltip = (isModalText = false) => {
        const hasACWRKey = Object.keys(cellInfo).some(key => key.endsWith('_ACWR'));
        if (!hasACWRKey) return;

        return (
            <>
                <span style={{fontWeight: 'bold'}}> ACWR: </span> <br/>
                {
                    key_metrics.map((metric, i) => {
                        const acwr_key = `${metric.key}_ACWR`;
                        const acwr_value = cellInfo[acwr_key];
                        const color = acwr_color(acwr_value);
            
                        return (
                            <span key={`${metric.key}_ACWR${i}`}>
                                {metric.name} : <span style={{color: color}}>{acwr_value !== undefined ? acwr_value : '-'}</span> <br/>
                            </span>
                        )}
                    )
                }
                {
                    isModalText && (<br></br>)
                }
            </>
        )
    }

    const getInjuryTooltip = (isModalText = false) => {
        const injuries = cellInfo?.injury || 0;
        if (injuries.length === 0) {
            return 
        }

        return (
            <>
                <span style={{fontWeight: 'bold'}}> Injuries: </span> <br/>
                {injuries.map((injury, idx) => {
                    return (
                        <div key={`${uniqueKey}_Injury_${idx}`}>
                            <p style={{marginBottom: '0px'}}>Type: {injury.injury_type}</p>
                            <p style={{marginBottom: '0px'}}>Location: {injury.injury_location}</p>
                            <p style={{marginBottom: '0px'}}>Start Date: {injury.injury_start_date}</p>
                            <p style={{marginBottom: '0px'}}>Injury Day: {moment(cellInfo.date).diff(moment(injury.injury_start_date), 'days') + 1}</p>
                            { !isModalText &&cellInfo?.injury.length !== idx + 1 &&
                                <hr style={{borderTopColor: 'white'}}/>
                            }
                            {
                                isModalText && (<br></br>)
                            }
                        </div>
                    )
                })}
                {
                    isModalText && (<br></br>)
                }
            </>
        )
    }

    const getFlagTooltip = (isModalText = false) => {
        const flags = cellInfo?.flags;
        const FlagsByType = {};
        Object.keys(flags).map((flagSlug) => {
            const flagMeta = flags[flagSlug];
            
            if (flag_names_by_type && Object.keys(flag_names_by_type).length > 0) {
                const flagNameAndType = flag_names_by_type[flagSlug] || "";
                if (flagNameAndType && flagNameAndType.length > 0) {
                    const [ flagName, flagType ] = flagNameAndType;
                    if (["Forceplate", "Testing"].includes(flagType)) {
                        if (Object.keys(FlagsByType).includes(flagType)) {
                            FlagsByType[flagType].push([flagName, flagMeta?.metrics || []]);
                        } else {
                            FlagsByType[flagType] = [[flagName, flagMeta?.metrics || []]];
                        }
                    } else {
                        if (Object.keys(FlagsByType).includes(flagType)) {
                            FlagsByType[flagType].push(flagName);
                        } else {
                            FlagsByType[flagType] = [flagName];
                        }
                    }
                }
            }
        })

        return (
            <>
                {
                    FlagsByType && Object.entries(FlagsByType).length > 0 && (
                        <>
                            <span style={{fontWeight: 'bold'}}> Flags: </span> <br/>
                            {
                                Object.entries(FlagsByType).map(([flagType, flagNames], i) => {
                                    return (
                                        <div key={`Flag${uniqueKey}${flagType}${i}`}>
                                            {
                                                (["Forceplate", "Testing"].includes(flagType)) 
                                                ?
                                                (
                                                    flagNames.map(([flagName, flaggedMetrics], j) => {
                                                        return (
                                                            (isModalText)
                                                            ?
                                                            (
                                                                <span key={`Flag${uniqueKey}${flagType}${flagName}${i}${j}`}>
                                                                    {flagName} {flaggedMetrics?.length > 0 ? `(${flaggedMetrics.join(", ")})` : ''} <br/>
                                                                </span>
                                                            )
                                                            :
                                                            (
                                                                <span key={`Flag${uniqueKey}${flagType}${flagName}${i}${j}`}>
                                                                    {flagName} ({flaggedMetrics?.length || 0}) <br/>
                                                                </span>
                                                            )
                                                        )
                                                    })
                                                ) 
                                                :
                                                (
                                                    flagNames.map((flagName, j) => {
                                                        return (
                                                            <span key={`Flag${uniqueKey}${flagType}${flagName}${i}${j}`}>
                                                                {flagName} ({flagType}) <br/>
                                                            </span>
                                                        )
                                                    })
                                                )
                                            }
                                            
                                        </div>
                                    )
                                })
                            }
                            { isModalText && (<br></br>) }
                        </>
                    )
                    
                }
            </>
        );
    }


    const handleCellClick = () => {
        if (cellInfo && Object.keys(cellInfo).length > 0) {
            setIsModalOpen(true);
        }
    }

    const handleCreateStatus = () => {
        setCustomInputVisible(true);
    }

    const handleCancel = () => {
        setIsModalOpen(false);
        setCustomInputVisible(false);
    }

    const selectStatus = (status) => {
        if (cellInfo?.status?.status_id === status?.id) {
            const params =  {
                status_id: status.id,
                player_id: player?.player_id,
                date: dateStr,
            }
            dispatch(deletePlayerStatus(uniqueKey, params));
            setSelectedTagBGColor(null);
            setSelectedTagStatusId(null);
        } else {
            const params =  {
                status_id: status.id,
                player_id: player?.player_id,
                date: dateStr,
            }
            dispatch(selectPlayerStatus(uniqueKey, params));
            setSelectedTagBGColor(status.color);
            setSelectedTagStatusId(status.id);
        }
    };

    const deleteCustStatus = (status) => {
        let proceedWithDelete = false;
        if (
            (status?.mapped_to_num_players === 1 && status.player_ids.includes(player?.player_id)) ||
            (status?.mapped_to_num_players === 0)
        ) {
            proceedWithDelete = true;
        }
        
        if (!proceedWithDelete) {
            notification.warning({
                message: `Status '${status.name}' is mapped to ${status?.mapped_to_num_players} player(s)`,
                description: "You need to remove all the usages of this status before you can delete it.",
                placement: 'top',
                style: {
                    width: '40rem'
                },
                duration: 10
            })
        } else {
            confirmStatusDelete(status);
        }
    };


    const confirmStatusDelete = (status) => {
        let start_date, end_date;
        if (dateHeaders && Object.keys(dateHeaders).length > 0) {
            const datesToQuery = Object.keys(dateHeaders);
            start_date = datesToQuery[0];
            end_date = datesToQuery[datesToQuery.length - 1];
        }

        const data = {
            status_id: status?.id,
            start_date,
            end_date
        }

        dispatch(deleteCustomStatus(uniqueKey, data, status.mapping));
    }

    const handleStatusEditClick = (e, status) => {
        e.stopPropagation(); // Prevents triggering Tag's onClick (if any)

        if(editingStatus !== null) {
            notification.warning({
                message: `Editing multiple statuses simultaneously is not permitted`,
                description: "Please complete the current edit before proceeding.",
                placement: 'top',
                style: {
                    width: '35rem'
                },
                duration: 5
            })
            return;
        }

        setEditingStatus(status);
    }

    const statusEditorHandler = () => {
        setEditingStatus(null); 
    }

    const statusCreatorHandler = () => {
        setCustomInputVisible(false); 
    }

    if (uniqueKeyCellLoading) {
        return <Spin indicator={<LoadingOutlined spin />} size="small" />
    }

    return (
        <>
            <div className="tracker-cell" style={{ backgroundColor: cellBGColor }} onClick={handleCellClick}>
                <div>
                    {cellInfo?.injury.length > 0 &&
                        <Tooltip 
                            title={getInjuryTooltip()}
                        >
                            <FaPlus style={{color: '#888888'}}/>
                        </Tooltip>
                    }
                    <Tooltip 
                        title={flagTooltipTxt}
                    >
                        <div className="tracker-cell-flag-container" style={{ minWidth:{FLAG_SIZE}, minHeight:{FLAG_SIZE} }}>
                            {
                                flagNum > 0 ?
                                (
                                    <svg fill="#000000" width={FLAG_SIZE} height={FLAG_SIZE} viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M217.78906,44.42639a4.00624,4.00624,0,0,0-4.18945.37793c-30.15039,22.61426-56.31934,11.39746-84.02441-.47656C101,32.08166,71.4502,19.4176,37.59961,44.80432c-.07227.0542-.12744.12158-.19482.17944a4.0389,4.0389,0,0,0-.31006.2854c-.08936.09522-.167.19629-.2461.29834-.0791.10254-.15771.20411-.227.31446s-.12744.22461-.18506.34033c-.0581.11621-.11523.2312-.16211.35327-.04638.12207-.08056.24609-.11523.37158-.03369.12329-.06836.24536-.09033.37329a4.01251,4.01251,0,0,0-.043.42627c-.00537.08692-.02588.16944-.02588.25782v168a4,4,0,0,0,8,0V170.05579c29.47852-21.042,55.21191-10.0376,82.4248,1.62548,16.43653,7.04395,33.19434,14.22657,50.90821,14.22657,13.082-.001,26.6875-3.91895,41.06738-14.70313A4.00206,4.00206,0,0,0,220,168.00452v-120A4.0023,4.0023,0,0,0,217.78906,44.42639ZM212,165.97522c-29.47852,21.041-55.21289,10.01562-82.4248-1.64746-26.75977-11.468-54.37452-23.29932-85.5752-3.908V50.05579c29.47852-21.042,55.21191-10.0376,82.4248,1.62548,26.76075,11.46778,54.376,23.30078,85.5752,3.91114Z"/>
                                        <text x="50%" y="46%" dominantBaseline="middle" textAnchor="middle" fill="red" fontSize="88px" fontWeight="bold">
                                            {flagNum}
                                        </text>
                                    </svg>
                                )
                                : 
                                (
                                    <></>
                                )
                            }
                        </div>
                    </Tooltip>
                </div>
                <Tooltip 
                    title={ACWRDotTooltipTxt}
                >
                    <div className="status-tracker-acwr-dot-container">
                        {ACWRDotContent}
                    </div>
                </Tooltip>
            </div>
            <Modal 
                title={`${player?.first_name} ${player?.last_name} - ${dateStr}`} 
                open={isModalOpen} 
                onCancel={handleCancel}
                footer={null} // Hides the default buttons
            >
                {
                    cellInfo && Object.keys(cellInfo).length > 0 && (
                        <div>
                            {getACWRTooltip(true)}
                            {getFlagTooltip(true)}
                            {getInjuryTooltip(true)}
                        </div>
                    )
                }
                <span><strong>Select Status:   </strong></span>
                {
                    uniqueKeyModalLoading && <Spin indicator={<LoadingOutlined spin />}/>
                }
                <br></br>
                <div className="modal-tag">
                    {
                        statuses && statuses.length > 0 && (
                            (statuses).map((status, i) => {
                                return (
                                    (editingStatus !== null && (editingStatus.id === status.id || editingStatus.status_id === status.id))
                                    ?
                                    (
                                       <StatusUpdater 
                                            key={`${uniqueKey}-modal-tag-${i}`}
                                            uniqueKey={uniqueKey}
                                            status={status}
                                            mode={"edit"}
                                            confirmCancelHandler={statusEditorHandler}
                                            dateHeaders={dateHeaders}
                                       />
                                    ) 
                                    :
                                    (
                                        <Tag
                                            className="modal-tag-individual"
                                            key={`${uniqueKey}-modal-tag-${i}`}
                                            closable={status.delete_allowed}
                                            style={{ 
                                                        backgroundColor: ((status.id === selectedTagStatusId) ? (selectedTagBGColor) : status.color), 
                                                        borderColor: ((status.id === selectedTagStatusId) ? 'black' : status.color), 
                                                        cursor: 'pointer' 
                                                    }}
                                            onClick={() => selectStatus(status)}
                                            onClose={(e) => {
                                                e.preventDefault(); 
                                                deleteCustStatus(status);
                                            }}
                                        >
                                            {status.name}
                                            { (status.edit_allowed) && (
                                                    <span 
                                                        onClick={e => handleStatusEditClick(e, status)} 
                                                        style={{ marginBottom: 4, marginLeft: 4, cursor: "pointer" }}
                                                    >
                                                        <GoPencil />
                                                    </span>
                                                )
                                            }
                                            
                                        </Tag>
                                    )
                                )
                            }
                        ))
                    }
                    {
                        customInputVisible ? (
                            <StatusUpdater 
                                uniqueKey={uniqueKey}
                                mode={"create"}
                                confirmCancelHandler={statusCreatorHandler}
                                dateHeaders={dateHeaders}
                            />
                        )
                        : 
                        (
                            <Tag className='modal-tag-individual custom-tag' icon={<PlusOutlined />} onClick={handleCreateStatus} >
                                New Status
                            </Tag>
                        )
                    }
                </div>
            </Modal>
        </>
    
    );
};
